import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=fbdb077c&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=fbdb077c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbdb077c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbdb077c')) {
      api.createRecord('fbdb077c', component.options)
    } else {
      api.reload('fbdb077c', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=fbdb077c&scoped=true&", function () {
      api.rerender('fbdb077c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-23DGhAcOnW510/JS/comp/PopupBox.vue"
export default component.exports